var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.60705 1.99119L7.3079 1.29031C7.695 0.903229 8.3226 0.903229 8.7097 1.29031C9.09675 1.6774 9.09675 2.30499 8.7097 2.69207L8.0088 3.39295M6.60705 1.99119L2.49012 6.10815C1.96747 6.6308 1.70613 6.8921 1.52818 7.21055C1.35023 7.529 1.1712 8.28095 1 9C1.71905 8.8288 2.471 8.64975 2.78945 8.4718C3.1079 8.29385 3.36922 8.03255 3.89188 7.5099L8.0088 3.39295M6.60705 1.99119L8.0088 3.39295",
    stroke: "#7C7C7C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.60705 1.99119L7.3079 1.29031C7.695 0.903229 8.3226 0.903229 8.7097 1.29031C9.09675 1.6774 9.09675 2.30499 8.7097 2.69207L8.0088 3.39295M6.60705 1.99119L2.49012 6.10815C1.96747 6.6308 1.70613 6.8921 1.52818 7.21055C1.35023 7.529 1.1712 8.28095 1 9C1.71905 8.8288 2.471 8.64975 2.78945 8.4718C3.1079 8.29385 3.36922 8.03255 3.89188 7.5099L8.0088 3.39295M6.60705 1.99119L8.0088 3.39295",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.60705 1.99119L7.3079 1.29031C7.695 0.903229 8.3226 0.903229 8.7097 1.29031C9.09675 1.6774 9.09675 2.30499 8.7097 2.69207L8.0088 3.39295M6.60705 1.99119L2.49012 6.10815C1.96747 6.6308 1.70613 6.8921 1.52818 7.21055C1.35023 7.529 1.1712 8.28095 1 9C1.71905 8.8288 2.471 8.64975 2.78945 8.4718C3.1079 8.29385 3.36922 8.03255 3.89188 7.5099L8.0088 3.39295M6.60705 1.99119L8.0088 3.39295",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.60705 1.99119L7.3079 1.29031C7.695 0.903229 8.3226 0.903229 8.7097 1.29031C9.09675 1.6774 9.09675 2.30499 8.7097 2.69207L8.0088 3.39295M6.60705 1.99119L2.49012 6.10815C1.96747 6.6308 1.70613 6.8921 1.52818 7.21055C1.35023 7.529 1.1712 8.28095 1 9C1.71905 8.8288 2.471 8.64975 2.78945 8.4718C3.1079 8.29385 3.36922 8.03255 3.89188 7.5099L8.0088 3.39295M6.60705 1.99119L8.0088 3.39295",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.1001115d3dab4bc89b63580e97d8f472.svg";
export { ForwardRef as ReactComponent };